import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { FormProps, Modal, ModalBody } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Blockquote from '../Blockquote';

import ModalHeader from '../ModalHeader';
import UploadDocForm from './UploadDocForm';

export type customUploadDocModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  handleClose: () => void;
  handleSubmit: (formData: any) => void;
  formProps?: FormProps;
}>;

const UploadDocModal = ({
  showModal = false,
  handleClose,
  handleSubmit,
  formProps,
  ...props
}: customUploadDocModalProps) => {
  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="lg">
      <ModalHeader leftIcon={light('upload')} closeButton>
        <h5>Upload your Documents</h5>
      </ModalHeader>
      <ModalBody className="pt-9">
        <section>
          <Blockquote>
            <span>
              You can view your documents and their status in the{' '}
              <Link className={'text-decoration-none'} to={{ pathname:'/documentCenter'}} onClick={handleClose}>
                Document center
              </Link>
              .
            </span>
          </Blockquote>
        </section>
        <section className="pt-12">
          <UploadDocForm
            handleClose={handleClose}
            handleOnSubmit={handleSubmit}
          />
        </section>
      </ModalBody>
    </Modal>
  );
};

export default UploadDocModal;
